import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import FiltroPG from "./filtro";
import SearchInput from "../../../../components/inputs/searchInput";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import { UseListMembros } from "../context/listMembrosConexoes";


interface HeaderTableConexaoProps {

}

const HeaderTableConexao: FunctionComponent<HeaderTableConexaoProps> = () => {

  const { pgs, getSearchPerNome, isLoading } = UseListMembros()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>

        <ModalExportar
          idLoadingData={isLoading}
          callDownloadExcel={() =>
            OpenExcelUniversal(
              pgs,
              ['nome', 'telefone', 'email', 'nomesede', 'nomecelula', 'data']
            )}
          callDownloadPdf={
            () =>
              DonwloadPdf(
                pgs,
                ['Nome', 'Telefone', 'Email', 'Sede', 'PG', 'Inscrição'],
                ['nome', 'telefone', 'email', 'nomesede', 'nomecelula', 'data'],
                pgs?.length, [],
                `${pgs?.length}`
              )
          }
        />
        <FiltroPG />
      </section>

      <SearchInput
        placeholder="Procure por nome ou pg"
        onChange={getSearchPerNome}
      />

      <section />
    </SecaoButao>
  </>);
}

export default HeaderTableConexao;
